'use-client';
import classnames from 'clsx';
import * as React from 'react';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import type {
  IContainerProps,
  IContainerImperativeActions,
} from '../../../Container.types';
import { ContainerLogic } from '../../shared/ContainerLogic';
import semanticClassNames from '../../../Container.semanticClassNames';
import styles from './ForkedRightRibbon.scss';

const ForkedRightRibbon: React.ForwardRefRenderFunction<
  IContainerImperativeActions,
  IContainerProps
> = (props, ref) => {
  return (
    <ContainerLogic
      {...props}
      ref={ref}
      className={classnames(styles.root, props.className)}
      renderSlot={({ containerChildren }) => (
        <>
          <div
            className={classnames(
              styles.bg,
              formatClassNames(
                semanticClassNames.root,
                ...(props.customClassNames || []),
              ),
            )}
          >
            <div className={styles.top}>
              <div className={styles.ribbon} />
            </div>
            <div className={styles.bottom}>
              <div className={styles.ribbon} />
            </div>
          </div>
          {containerChildren}
        </>
      )}
    />
  );
};

export default React.forwardRef(ForkedRightRibbon);
